
<template>
    <van-dialog
        v-model="showDialog"
        :show-cancel-button="false"
        :show-confirm-button="false"
        class="sendTipsDialog"
        get-container="body"
        >
        <div class="sendTips">
            <div class="inputBox">
                <span class="text">手机号：</span>
                <input v-model="phone" @focus="inputFocus" @blur="inputBlur" placeholder="请输入手机号码" />
            </div>
            <div class="inputBox">
                <span class="text">验证码：</span>
                <input v-model="code" @focus="inputFocus" @blur="inputBlur" class="codeInput" placeholder="请输入验证码" />

                <countDown ref="countDown" :timestamp="countDownSec" @callBack="onCountDownCallBack">
                    <button :class="{sendCode: true, countDownEnd: !countDownEnd}" @click="sendCode">{{ countDownEnd ?  '发送验证码' : `倒计时(${countDownSec})` }}</button>
                </countDown>
            </div>
            <!-- 为了解决app 安卓 webview 键盘弹出2次问题增加蒙尘 -->
            <div class="sendTipsMask" v-show="disabled_mask"></div>
        </div>
        <div class="btnBox">
            <button class="cancel" @touchend="onBtn('cancel')">不用了</button>
            <button class="confirm" @touchend="onBtn('confirm')">确认</button>
        </div>
    </van-dialog>
</template>

<script>
import {
    sendSmsCaptcha,
    seckillGoodsRemind
} from '@/models/seckill'

import countDown from '@/components/countDown/countDown.vue'
export default {
    name: 'seckillSendTips',
    props: {
    },
    components: {
        countDown
    },
    data () {
        return {
            sstore_id: '', // 门店ID
            activity_id: '', // 秒杀活动id
            goods_id: '', // goods_id 就是spu_id,对于活动商品表的goods_id
            showDialog: false, // 是否显示提示框
            phone: '', // 手机号
            code: '', // 验证码
            countDownEnd: true, // 倒计时是否结束
            initSec: 60, // 初始化（不操作这个数字）
            countDownSec: 60, // 倒计时数字（操作）
            disabled_mask: false, // 显示蒙层
            // disabled_input: false, // 文本框 disabled
        }
    },
    created () {

    },
    activated () {

    },
    mounted () {
    },
    methods: {
        inputFocus () {
            // if (this.$bridge.isStore()) {
            //     this.disabled_mask = true
            // }
        },
        inputBlur () {
            this.disabled_mask = false
        },
        show (obj) {
            this.showDialog = true
            this.activity_id  = obj.activity_id
            this.sstore_id = obj.sstore_id
            this.goods_id = obj.goods_id
        },
        /**
         * 弹窗关闭前判断是否要关闭
         */
        onBtn (action) {
            /* 取消 */
            if (action === 'cancel') {
                this.onReset()
                this.showDialog = false
            } else if (action === 'confirm') {
                let reg = /^1\d{10}$/
                if (!reg.test(this.phone)) {
                    this.$toast('手机号码不正确')
                    return
                }
                if (this.code === '') {
                    this.$toast('验证码不能为空')
                    return
                }
                this.onConfirm()
            }
        },
        /**
         * 倒计时
         */
        onCountDownCallBack (timeInfo) {
            this.countDownSec = timeInfo.s
            /* 倒计时结束 */
            if (timeInfo.s === 0 && timeInfo.h === 0 && timeInfo.m === 0) {
                this.countDownEnd = true
                this.countDownSec = this.initSec
            }
        },
        /**
         * 确定发送提示
         */
        async onConfirm () {
            // this.disabled_mask = false
            const params = {
                sstore_id: this.sstore_id,
                activity_id: this.activity_id,
                activity_goods_id: this.goods_id,
                phone_mob: this.phone,
                verify_code: this.code,
            }
            try {
                await seckillGoodsRemind(params)
                this.$toast('我们将在活动前5分钟短信通知您')
                this.showDialog = false
                this.onReset()
                this.$emit('sendState', {
                    state: 'success',
                    id: this.goods_id
                })
            } catch (err) {
                this.$toast(err.errmsg)
            }
        },
        /**
         * 重置
         */
        onReset () {
            this.countDownEnd = true
            this.countDownSec = this.initSec
            this.code = ''
            this.$refs.countDown.end()
        },
        async sendCode () {
            if (this.countDownEnd) {
                let reg = /^1\d{10}$/
                if (reg.test(this.phone)) {
                    try {
                        await sendSmsCaptcha({
                            phone_mob: this.phone
                        })
                        this.$toast('已发送手机验证码，请注意查看~')
                        this.$refs.countDown.start()
                        this.countDownEnd = false
                    } catch (err) {
                        this.$toast(`发送失败 ${err.errmsg}`)
                    }
                } else {
                    this.$toast('手机号码不正确')
                }
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '../../../../assets/stylus/variables'
.btnBox
    font-size 0
    display flex
    border-top 1px solid #eee
    button
        flex 1
        display block
        text-align center
        font-size 36px
        height 100px
        line-height 50px
        border none
        background none
    button.cancel
        color #999
        border-right 1px solid #eee
    button.confirm
        color #fd2d2d
.sendTips
    padding 50px 35px
    position relative
    .sendTipsMask
        position absolute
        top 0
        left 0
        background rgba(0,0,0, 0)
        width 100%
        height 100%
    .inputBox
        display flex
        height 60px
        line-height 60px
        margin-bottom 20px
        .text
            color #666
            font-size 28px
            display block
            width 130px
        input
            flex 1
            width 100px
            height 100%
            color #033333
            display block
            background #eeeeee
            padding 0 16px
            font-size 28px
        .sendCode
            font-size 22px
            color #fd2d2d
            border 2px solid #fd2d2d
            width 160px
            height 100%
            display block
            outline none
            border-radius 6px
            background none
            margin-left 14px
        .countDownEnd
            border 2px solid #c7c5c5
            color #777
            font-size 22px
</style>
<style lang="stylus">
body
    .sendTipsDialog
        border-radius 40px !important
        top 30%
        .van-dialog__confirm
            color #fd2d2d
</style>
